import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

const TRACK_HEIGHT = 28;
const TRACK_WIDTH = 58;
const TRACK_RADIUS = TRACK_HEIGHT / 2;
const THUMB_WIDTH = 32;
const THUMB_HEIGHT = 22;
const THUMB_MARGIN = 3;
const THUMB_RADIUS = THUMB_HEIGHT / 2;

/** Distance the thumb slides (for animation). */
export const LIVE_TOGGLE_THUMB_TRAVEL = TRACK_WIDTH - THUMB_WIDTH - THUMB_MARGIN * 2;

export const getLiveFilterToggleStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: TRACK_WIDTH,
      height: TRACK_HEIGHT,
      borderRadius: TRACK_RADIUS,
      justifyContent: 'center',
      overflow: 'hidden',
    },
    containerPressed: {
      opacity: 0.9,
    },
    track: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: theme.gray[200],
      borderRadius: TRACK_RADIUS,
    },
    thumb: {
      position: 'absolute',
      left: THUMB_MARGIN,
      top: (TRACK_HEIGHT - THUMB_HEIGHT) / 2,
      width: THUMB_WIDTH,
      height: THUMB_HEIGHT,
      borderRadius: THUMB_RADIUS,
      backgroundColor: theme.gray[500],
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      zIndex: 1,
    },
    thumbActiveOverlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: theme.error,
      borderRadius: THUMB_RADIUS,
    },
    thumbLabel: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.white,
      zIndex: 1,
    },
  });
